import axios from '../../util/axios';

import {
    startAnim,
} from '../../util/util';
import Easing from '../../util/Easing';

const PLAND_COLORS = {
    '建筑用地': 'rgba(171, 255, 254, 0.8)',
    '绿化用地': 'rgba(87, 255, 132, 0.8)',
    '居民用地': 'rgba(241, 255, 87, 0.8)',
    '商业用地': 'rgba(255, 160, 87, 0.8)',
    '交通用地': 'rgba(255, 116, 41, 0.8)',
    '水利用地': 'rgba(0, 217, 255, 0.8)',
};

const PIPE_CONFIG = {
    'DSLINE': {
        name: '电视管网',
        color: 'rgb(253, 132, 14)',
        width: 0.4,
        deep: -4
    },
    'JSLINE': {
        name: '给水管网',
        color: 'rgb(0, 0, 255)',
        width: 0.8,
        deep: -30
    },
    'NLLINE': {
        name: '电力管网',
        color: 'rgb(255, 255, 0)',
        width: 0.4,
        deep: -15
    },
    'RQLINE': {
        name: '燃气管网',
        color: 'rgb(255, 0, 0)',
        width: 0.8,
        deep: -18
    },
    'TXLINE': {
        name: '通信管网',
        color: 'rgb(250, 37, 254)',
        width: 0.4,
        deep: -8
    },
    'WSLINE': {
        name: '污水管网',
        color: 'rgb(103, 0, 12)',
        width: 0.8,
        deep: -45
    },
    'YSLINE': {
        name: '雨水管网',
        color: 'rgb(0, 255, 248)',
        width: 0.8,
        deep: -35
    },
    'ZSLINE': {
        name: '中水管网',
        color: 'rgb(102, 204, 0)',
        width: 0.6,
        deep: -25
    },
};

/**
 * 园区规划
 */
export default class ParkPlanning {
    constructor(main) {
        this.main = main;
        this.g2d = main.g2d;
        this.dm = main.g2d.dm();
        this.regionCount = 0;
        this.htAnims = {};
        this.pipeLayers = [];
    }

    /**
     * 初始化 2D 面板上的数据
     */
    init() {
        const dm = this.dm;
        // 左侧
        const parkPanel = this.parkPanel = dm.getDataByTag('parkPlanningPanel');
        const regionPanel = this.regionPanel = dm.getDataByTag('regionPlanningPanel');
        // 右侧
        const landPanel = this.landPanel = dm.getDataByTag('landPlanningPanel');
        const facilitiesPanel = this.facilitiesPanel = dm.getDataByTag('facilitiesPlanningPanel');
        const pipePanel = this.pipePanel = dm.getDataByTag('pipePlanningPanel');

        this.regionCount = 0;

        axios.get('getParkPlanningInfo').then(res => {
            this.subjectDatas = res;
            this.regionNames = Object.keys(res.regionArea);
            regionPanel.getChildAt(1).getChildAt(0).s('text', this.regionNames[0]);
            const _data = res.regionArea[this.regionNames[0]];
            const planningLandType = regionPanel.getChildAt(2);
            planningLandType.eachChild((node,i) => {
                node.a({
                    iconType: _data[i].name,
                    value: _data[i].value
                });
                node.setScaleX(1);
            });
            landPanel.getChildAt(1).a(res.landPlanning);
            facilitiesPanel.getChildAt(1).a(res.facilities);
            const chartValue = Object.values(res.facilities);
            const chartNode = facilitiesPanel.getChildAt(2);
            chartNode.a('seriesData', chartValue);

            // 管网规划的面板
            pipePanel.getChildAt(1).a('wellCount', 0);
            pipePanel.getChildAt(2).a('seriesData', [0,0,0,0]);
            pipePanel.getChildAt(2).a('axaxisData', res.pipeNameLength);

            const parkInfoPanel = parkPanel.getChildAt(1);
            parkInfoPanel.a({
                name: this.regionNames[0],
                area: parseInt(res.parkInfo['A 区'].area),
                building: parseInt(res.parkInfo['A 区'].building),
                busRoutes: parseInt(res.parkInfo['A 区'].busRoutes),
                busStations: parseInt(res.parkInfo['A 区'].busStations),
            });

            this.regionCount++;
            this.start2DAnim();

            // 地块规划图例
            const landLegend = this.dm.getDataByTag('landLegend');
            landLegend.a(res.landLegendData);
            // pipeLegend
            const pipeLegend = this.dm.getDataByTag('pipeLegend');
            pipeLegend.a(res.pipeLegendData);
        });
    }

    /**
     * 启动 2D 上的动画
     */
    start2DAnim() {
        // 先清除动画,避免重复调用 start2DAnim 但未调用过 stop2DAnim 的误操作.
        this.stop2DAnim();

        const regionPanel = this.regionPanel;
        const planningLandType = regionPanel.getChildAt(2);
        const parkInfoPanel = this.parkPanel.getChildAt(1);

        const regionNames = this.regionNames;
        const regionArea = this.subjectDatas.regionArea;
        const lenLastIndex = planningLandType.getChildren().size() - 1;
        let name = regionNames[this.regionCount];
        const parkInfoDatas = this.subjectDatas.parkInfo;
        let parkInfoData = parkInfoDatas[name];

        this.htAnims.pipeChartAnim = startAnim({
            duration: 3000,
            easing: t => t,
            action: v => {
                const _value = this.subjectDatas.pipeLength.map(value => {
                    return parseInt(value * v);
                });
                this.pipePanel.getChildAt(2).a('seriesData', _value);
                this.pipePanel.getChildAt(1).a('wellCount', parseInt(this.subjectDatas.well * v));
            }
        });
        
        this.htAnims.parkInfoCircleAnim = startAnim({
            interval: 20,
            frames: Infinity,
            action: () => {
                const currentAngle = parkInfoPanel.a('rotation') || 0;
                parkInfoPanel.a('rotation', currentAngle + Math.PI / 90);
            }
        });

        const parkInfoParams = {
            delay: 3000,
            duration: 1500,
            easing: t => t,
            action: v => {
                parkInfoPanel.a({
                    name: name,
                    area: parseInt(parkInfoData.area * v),
                    building: parseInt(parkInfoData.building * v),
                    busRoutes: parseInt(parkInfoData.busRoutes * v),
                    busStations: parseInt(parkInfoData.busStations * v),
                });
            },
            finishFunc: () => {        
                const _data = regionArea[name];
                regionPanel.getChildAt(1).getChildAt(0).s('text', regionNames[this.regionCount]);
                planningLandType.eachChild((node,i) => {
                    this.htAnims[`regionPlanningAnim${i}`] = startAnim({
                        delay: i * 200,
                        duration: 2000,
                        easing: t => Math.sin(t * Math.PI),
                        action: v => {
                            node.setScaleX(1 - v);
                            if(v > 0.98) {
                                node.a({
                                    iconType: _data[i].name,
                                    value: _data[i].value
                                });
                            }
                        },
                        finishFunc: () => {
                            if(i === lenLastIndex) {
                                this.regionCount += 1;
                                if(this.regionCount > 2) {
                                    this.regionCount = 0;
                                }
                                name = regionNames[this.regionCount];
                                parkInfoData = parkInfoDatas[name];
                                this.htAnims.parkInfoAnim = startAnim(parkInfoParams);
                            }
                        }
                    }); 
                });
            }
        }
        this.htAnims.parkInfoAnim = ht.Default.startAnim(parkInfoParams);
        
    }

    /**
     * 停止移除 2D 上的动画
     */
    stop2DAnim() {
        Object.values(this.htAnims).forEach(anim => {
            anim.pause();
        });
        this.htAnims = {};
    }
    
    /**
     * 开启用地规划图层
     */
    openLandPlanning() {
        const {
            main,
            dm,
            subjectDatas
        } = this;
        const pageMap = main.pageMap;
        const map = pageMap.map;

        this.closeLandPlanning();
        this.closePipePlanning();

        const landLegend = dm.getDataByTag('landLegend');
        landLegend && landLegend.s('2d.visible', true);
        const pipePlanning = dm.getDataByTag('pipePlanning');
        pipePlanning.a('active', false);
        pipePlanning.s('state', '默认');
        
        map.flyTo({
            // heading: 233.76914438210923,
            // height: 2404.187884680145,
            // pitch: -89.99999402358448,
            // position: [118.04038125851027, 24.616959990772173],
            // roll: 0,
            heading: 233.76914438210912,
            height: 1580.3677723424494,
            pitch: -89.99999446691439,
            position: [118.0409566347237, 24.616797221556034],
            roll: 0,
            animation: {
                duration: 2000
            }
        }, () => {
            if(!this.landLayer) {
                this.landLayer = [];
                const names = Object.keys(subjectDatas.mapLand);
                const values = Object.values(subjectDatas.mapLand);
                values.forEach((value,i) => {
                    const landPositions = value.map(v => {
                        const _allPoints = [];
                        v.positions.forEach(v2 => {
                            _allPoints.push(v2[0], v2[1]);
                        })
                        return _allPoints;
                    });
                    const polygon = new ht.cesium.Polygon({
                        id: `land-Layer-${i}`,
                        classType: 'BOTH',
                        // primitiveType: 'Primitive',
                        positions: landPositions,
                        color: PLAND_COLORS[names[i]],
                        outline: false,
                        // outlineWidth: 10,
                        // outlineColor: 'rgba(0,0,0,0.7)'
                    });
                    map.add(polygon);
                    this.landLayer.push(polygon);
                });
            }
        });
    }

    /**
     * 关闭用地规划图层
     */
    closeLandPlanning() {
        const dm = this.dm;
        const pageMap = this.main.pageMap;
        pageMap.setHomeView();
        
        const landLegend = dm.getDataByTag('landLegend');
        landLegend && landLegend.s('2d.visible', false);

        if(this.landLayer) {
            this.landLayer.forEach(node => {
                node.remove();
            });
            this.landLayer = null;
        }
    }
    
    /**
     * 开启管网规划图层
     */
     openPipePlanning() {
        const dm = this.dm;
        const main = this.main;
        const pageMap = main.pageMap;
        const map = pageMap.map;

        this.closeLandPlanning();
        this.closePipePlanning();

        const pipeLegend = dm.getDataByTag('pipeLegend');
        pipeLegend && pipeLegend.s('2d.visible', true);
        const landPlanning = dm.getDataByTag('landPlanning');
        landPlanning.a('active', false);
        landPlanning.s('state', '默认');
        
        map.flyTo({
            heading: 175.27200712501684,
            height: 540.0149872282178,
            pitch: -54.386735477707425,
            position: [118.0381536347416, 24.62281041045292],
            roll: 0.00035805626971630033,
            animation: {
                duration: 2000
            }
        }, () => {
            pageMap.set3DTilesSceneOpacity(0.1);
            const rangePoints = [
                Cesium.Cartesian3.fromDegrees(118.03902404423093, 24.620799676450066),
                Cesium.Cartesian3.fromDegrees(118.03706233155837, 24.619528057980318),
                Cesium.Cartesian3.fromDegrees(118.03803013003628, 24.618577728709816),
                Cesium.Cartesian3.fromDegrees(118.0398285893203,  24.619780770995295)
            ];

            const pointsLength = rangePoints.length;
            const clippingPlanes = [];
            for (let i = 0; i < pointsLength; ++i) {
                let nextIndex = (i + 1) % pointsLength;
                let midpoint = Cesium.Cartesian3.add(rangePoints[i], rangePoints[nextIndex], new Cesium.Cartesian3());
                midpoint = Cesium.Cartesian3.multiplyByScalar(midpoint, 0.5, midpoint);

                let up = Cesium.Cartesian3.normalize(midpoint, new Cesium.Cartesian3());
                let right = Cesium.Cartesian3.subtract(rangePoints[nextIndex], midpoint, new Cesium.Cartesian3());
                right = Cesium.Cartesian3.normalize(right, right);

                let normal = Cesium.Cartesian3.cross(right, up, new Cesium.Cartesian3());
                normal = Cesium.Cartesian3.normalize(normal, normal);

                let originCenteredPlane = new Cesium.Plane(normal, 0.0);
                let distance = Cesium.Plane.getPointDistance(originCenteredPlane, midpoint);

                clippingPlanes.push(new Cesium.ClippingPlane(normal, distance));
            }

           const node = this.clipNode = new ht.cesium.Node({
                id: 'clipNode',
                lnglat: [118.0384417379634, 24.61965009602713],
                nodeRender: 'GIS',
                height: -50,
                scale: 1,
            });
            map.add(node, () => {
                node.setWidth(150);
                node.setHeight(250);
                node.setTall(59);
                node.rotationY = Math.PI / 180 * 44;
                node.s({
                    '2d.editable': false,
                    '2d.movable': false,
                    '2d.visible': true,
                    '3d.movable': false,
                    '3d.visible': true,
                    'interactive': false,
                    'shape3d.transparent': true,
                    'shape3d.opacity': 0.6,
                    'wf.geometry': false,
                    'shape3d.color': '#DDDDDD',
                    'all.visible': false,
                    'front.visible': true,
                    'back.visible': true,
                    'left.visible': true,
                    'right.visible': true,
                    'top.visible': false,
                    'bottom.visible': true,
                    'all.reverse.flip': true,
                    'bottom.image': '../data/land/land1.jpg',
                    'front.image': '../data/land/land2.jpg',
                    'back.image': '../data/land/land2.jpg',
                    'left.image': '../data/land/land0.jpg',
                    'right.image': '../data/land/land0.jpg'
                });
            });

            if(!this.clippingPlanesEntity) {
                this.clippingPlanesEntity = new Cesium.ClippingPlaneCollection({
                    // modelMatrix: entity.computeModelMatrix(Cesium.JulianDate.now()),
                    // planes: [
                    //     new Cesium.Plane(new Cesium.Cartesian3(1.0, 0.0, 0.0), -95.0),
                    //     new Cesium.Plane(new Cesium.Cartesian3(-1.0, 0.0, 0.0), -95.0),
                    //     new Cesium.Plane(new Cesium.Cartesian3(0.0, 1.0, 0.0), -95.0),
                    //     new Cesium.Plane(new Cesium.Cartesian3(0.0, -1.0, 0.0), -95.0)
                    // ],
                    planes: clippingPlanes,
                    enabled: true,
                    edgeWidth: 0.0,
                    edgeColor: Cesium.Color.YELLOW
                });
            }
            else {
                this.clippingPlanesEntity.enabled = true;
            }
            map.cesiumScene.globe.clippingPlanes = this.clippingPlanesEntity;

            if(this.pipeLayers.length > 0) {
                this.pipeLayers.forEach(layer => {
                    layer.remove();
                });
            }
            this.pipeLayers = [];

            Object.keys(PIPE_CONFIG).forEach(name => {
                ht.Default.xhrLoad(`../data/pipes/${name}.json`, textJson => {
                    if(!textJson) return;
                    const pipeData = JSON.parse(textJson);
                    const _config = PIPE_CONFIG[name];
                    let _data = [];
                    pipeData.features.forEach(value => {
                        let __data = [];
                        value.geometry.coordinates.forEach(v => {
                            __data.push(v[0] + 0.002, v[1] + 0.002, _config.deep);    
                        });
                        _data.push(__data);
                    });
                    const layer = new ht.cesium.Pipe({
                        positions: _data,
                    	width: _config.width,
                    	color: _config.color
                    });
                    map.add(layer);
                    this.pipeLayers.push(layer);
                });
            });

            pageMap.map.earthDepthTestAgainstTerrain = true;
            // pageMap.scene3DTiles['software-park-B'].layer.clippingPlanes = clippingPlanesEntity
        });
    }

    /**
     * 关闭管网规划图层
     */
    closePipePlanning() {
        const dm = this.dm;
        const pageMap = this.main.pageMap;
        pageMap.setHomeView();
        pageMap.set3DTilesSceneOpacity(1);
        if(this.clippingPlanesEntity) {
            this.clippingPlanesEntity.enabled = false;
        }
        pageMap.map.earthDepthTestAgainstTerrain = false;
        const pipeLegend = dm.getDataByTag('pipeLegend');
        pipeLegend && pipeLegend.s('2d.visible', false);

        if(this.pipeLayers.length > 0) {
            this.pipeLayers.forEach(layer => {
                layer.remove();
            });
            this.pipeLayers = [];
        }
        if(this.clipNode) {
            this.clipNode.remove();
            this.clipNode = null;
        }
    }

    /**
     * 清除关闭所有动画及数据更新
     */
    clear() {
        this.closeLandPlanning();
        this.closePipePlanning();

        this.stop2DAnim();
    }
}